import $ from 'jquery';
import {Moment} from 'moment';
import React from 'react';

import {ElementMouseEvent} from 'util/Types';

import CalendarActions from './CalendarActions';

interface Props {
  date: Moment;
  children: (onMouseDown: (e: ElementMouseEvent) => void) => JSX.Element;
}

export default class MouseDownCapturer extends React.Component<Props> {
  componentWillUnmount(): void {
    this.removeListeners();
  }

  onMouseUp(e: ElementMouseEvent): void {
    this.removeListeners();
    CalendarActions.dayMouseUp(e.clientX, e.clientY);
  }

  onMouseDown(e: ElementMouseEvent): void {
    if (e.button !== 0) {
      return;
    }
    CalendarActions.dayMouseDown(this.props.date);
    $(window).on('mouseup', (e: JQueryEventObject) => {
      this.onMouseUp(e as unknown as ElementMouseEvent);
    });
  }

  removeListeners(): void {
    $(window).off('mouseup', (e: JQueryEventObject) => {
      this.onMouseUp(e as unknown as ElementMouseEvent);
    });
  }

  render(): JSX.Element {
    return this.props.children((e) => {
      this.onMouseDown(e);
    });
  }
}
